import { render } from "./CommandBtn.vue?vue&type=template&id=0c990398&scoped=true"
import script from "./CommandBtn.vue?vue&type=script&lang=js"
export * from "./CommandBtn.vue?vue&type=script&lang=js"

import "./CommandBtn.vue?vue&type=style&index=0&id=0c990398&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c990398"]])

export default __exports__